import React from 'react';

interface TwitterProps {
    color?: string;
    width?: string;
    height?: string;
}

const Twitter: React.FC<TwitterProps> = ({
    color = '#05668D',
    width,
    height
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 41 40"
            fill="none"
        >
            <g clipPath="url(#clip0_1208_643)">
                <path
                    d="M20.4996 0C9.47197 0 0.5 8.97181 0.5 19.9996C0.5 31.0278 9.47197 40 20.4996 40C31.528 40 40.5 31.0278 40.5 19.9996C40.4996 8.97181 31.5277 0 20.4996 0ZM31.1442 14.7835C30.6139 15.5776 29.9544 16.2774 29.1931 16.8538C29.1963 16.9699 29.1984 17.0859 29.1984 17.202C29.1984 23.0344 24.7603 29.0671 17.3331 29.0671C15.0665 29.0682 12.8474 28.4183 10.9396 27.1947C10.8715 27.1512 10.8203 27.086 10.7942 27.0096C10.7681 26.9333 10.7688 26.8503 10.796 26.7744C10.8225 26.698 10.8744 26.633 10.943 26.5903C11.0117 26.5475 11.0929 26.5296 11.1731 26.5394C11.4863 26.5755 11.7966 26.5933 12.0958 26.5933C13.5527 26.5933 14.941 26.2016 16.1597 25.4532C15.4257 25.2761 14.7497 24.9129 14.1967 24.3988C13.6438 23.8847 13.2325 23.2369 13.0024 22.5177C12.9836 22.4587 12.9804 22.3957 12.9932 22.3351C13.0059 22.2745 13.0342 22.2182 13.0753 22.1717C13.1163 22.1252 13.1688 22.0903 13.2276 22.0704C13.2864 22.0505 13.3493 22.0464 13.4102 22.0585C13.4773 22.0714 13.5448 22.0824 13.6119 22.0917C12.3718 21.3015 11.5673 19.9122 11.5673 18.3739V18.3228C11.5673 18.2607 11.5836 18.1996 11.6145 18.1457C11.6453 18.0918 11.6897 18.0468 11.7433 18.0153C11.7968 17.9838 11.8577 17.9668 11.9198 17.966C11.982 17.9652 12.0432 17.9806 12.0976 18.0107C12.2529 18.0968 12.4139 18.1714 12.5793 18.2343C11.9447 17.45 11.599 16.4715 11.6002 15.4627C11.6002 14.685 11.8062 13.9194 12.1958 13.2492C12.2248 13.1992 12.2654 13.157 12.3143 13.1263C12.3632 13.0955 12.4188 13.077 12.4764 13.0724C12.534 13.0679 12.5918 13.0773 12.6449 13.1C12.6981 13.1227 12.7449 13.158 12.7814 13.2028C14.6807 15.5316 17.4416 16.9967 20.4114 17.2666C20.3904 17.0897 20.3799 16.9117 20.38 16.7335C20.38 14.3065 22.355 12.3319 24.7824 12.3319C25.9276 12.3319 27.0356 12.7836 27.853 13.577C28.6518 13.3991 29.4173 13.0955 30.1208 12.6775C30.1383 12.6224 30.169 12.5724 30.2102 12.5318C30.2513 12.4912 30.3017 12.4611 30.357 12.4443C30.4123 12.4275 30.4709 12.4243 30.5277 12.4351C30.5845 12.4459 30.6378 12.4703 30.6831 12.5063C30.7284 12.5423 30.7643 12.5887 30.7876 12.6416C30.811 12.6945 30.8212 12.7522 30.8173 12.8099C30.8134 12.8676 30.7955 12.9235 30.7653 12.9728C30.735 13.022 30.6932 13.0632 30.6435 13.0928C30.4687 13.641 30.1871 14.1492 29.8151 14.5882C30.1177 14.4968 30.4143 14.3866 30.7032 14.2583C30.7739 14.227 30.8529 14.2196 30.9282 14.2371C31.0036 14.2546 31.0712 14.2961 31.1209 14.3553C31.1706 14.4145 31.1998 14.4883 31.204 14.5655C31.2082 14.6428 31.1872 14.7193 31.1442 14.7835Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1208_643">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Twitter;
